import { useQuery } from '@tanstack/react-query';
import { subscriptionApi } from '~/lib/request';
import { Subscription } from './types';

function useActiveSubscription() {
  const result = useQuery({
    queryKey: ['activeSubscription'],
    queryFn: () => subscriptionApi.get('api/subscriptions/active').json<Subscription>(),
    throwOnError: true,
  });

  return { data: result?.data, isLoading: result.isLoading };
}

export default useActiveSubscription;
